import { apiClient } from "../../../services/apiClient";
import { API_ENDPOINTS } from "../../../config/apiEndpoints";

export const sidebarService = {
  getDrawerNav: async () => {
    const res = await apiClient.get(API_ENDPOINTS.SIDEBAR.DRAWER_NAV);
    return res?.data ?? res ?? [];
  },
  getSocialLinks: async () => {
    const res = await apiClient.get(API_ENDPOINTS.SIDEBAR.SOCIAL_LINKS);
    return res?.data ?? res ?? [];
  },
};
